import {
  LoadingButton,
  type TpButtonLoadingProps,
} from '@mentalgrowth/ui-kit-web';

export const UiKitLoadingButton = (props: TpButtonLoadingProps) => (
  <LoadingButton {...props} />
);
